module.exports = __webpack_public_path__ + "static/media/arrow-vazio-verde.bf514e33.svg";